import { Button, Image } from '@arco-design/web-react';
import { IconImage, IconImageClose } from '@arco-design/web-react/icon';
import React, { useState } from 'react';

export function DisplayImage({ src, show = false }: { src: string; show?: boolean }) {
  const [visible, setVisible] = useState(false);
  if (src.length === 0) {
    return null;
  }
  if (show) {
    return (
      <Image
        height={60}
        width={60}
        src={src}
        alt="..."
        error={
          <div className="flex flex-col items-center justify-center w-full h-full">
            <IconImageClose fontSize={30} />
          </div>
        }
      />
    );
  }
  return (
    <>
      <Button
        icon={<IconImage />}
        onClick={() => setVisible(true)}
        shape="circle"
        type="secondary"
      />
      <Image.Preview
        src={src}
        visible={visible}
        onVisibleChange={setVisible}
        className="object-contain"
      />
    </>
  );
}
